<template lang="pug">
div
  Form(:data="location", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useLocationAdd from './useLocationAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, location, isSubmitting } = useLocationAdd()

    return {
      location,
      create,
      isSubmitting,
    }
  },
}
</script>
